import wsClient from "../core/wsClient";
import emitter from "../core/wsEmitter";

// Переключение между сессиями
export const sessionService = {
	switchSession(sessionId: any) {
		if (!sessionId) return;
		/* 
			Для session-data устанавливаем статус загрузки: true
			чтобы в компоненте показывать прелоадер
		*/
		const request = { type: "session.switch", session_id: sessionId };

		if (wsClient.sendMessage) {
			wsClient.sendMessage(request);
		} else {
			wsClient.send("session.switch", { session_id: sessionId });
		}
	},

	waitForSessionSwitch(sessionId: string, timeoutMs = 8000): Promise<void> {
		return new Promise((resolve, reject) => {
			const cleanup = () => {
				emitter.off("session.switch_success", onSuccess);
				emitter.off("session.switch_error", onError);
				window.clearTimeout(timerId);
			};

			const onSuccess = (data: { session_id?: string }) => {
				if (data?.session_id !== sessionId) return;
				cleanup();
				resolve();
			};

			// Толерантная политика: switch_error тоже завершает ожидание,
			// а не висит до таймаута (например, сессия ещё не создана на сервере).
			// Сервер не всегда кладёт session_id в switch_error — завершаем
			// любой ожидаемый switch, если id не указан.
			const onError = (data: { session_id?: string; message?: string }) => {
				if (data?.session_id && data.session_id !== sessionId) return;
				cleanup();
				resolve();
			};

			const timerId = window.setTimeout(() => {
				cleanup();
				reject(new Error("Session switch timeout"));
			}, timeoutMs);

			emitter.on("session.switch_success", onSuccess);
			emitter.on("session.switch_error", onError);
		});
	},
};
